import { ENTITY_TABS, EntityCreationResult, EntityTab, WidgetView } from './create-entity-element.types';

/**
 * A one-shot command targeted at a specific tab's form, tagged with an incrementing token so
 * repeated commands for the same tab (e.g. two consecutive failed submits) are each observed as a
 * distinct change. Used by `CreateEntityWizardStore.submitRequest`/`resetRequest`.
 */
export interface TabCommand {
    tab: EntityTab;
    token: number;
}

export interface CreateEntityWizardState {
    activeTab: EntityTab;
    /** The tabs the host asked to show, in the widget's fixed order. */
    visibleTabs: readonly EntityTab[];
    view: WidgetView;
    submitting: boolean;
    errorMessage: string | null;
    /** Each tab is submitted (and created) independently, so only one entity is ever the result of a given submission. */
    result: EntityCreationResult | null;
    submitRequest: TabCommand | null;
    resetRequest: TabCommand | null;
}

export const INITIAL_CREATE_ENTITY_WIZARD_STATE: CreateEntityWizardState = {
    activeTab: 'organization',
    visibleTabs: ENTITY_TABS,
    view: 'form',
    submitting: false,
    errorMessage: null,
    result: null,
    submitRequest: null,
    resetRequest: null
};
